import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";
import RuleDefinitionImporter from "@dndComponents/RuleDefinitionImporter";

export default function RuleDefinitionIndex() {
  return (
    <NonFSIndex
      data_type="rule_definition"
      extra_by_add={() => <RuleDefinitionImporter />}
    />
  );
}
